import { render, staticRenderFns } from "./inspection.vue?vue&type=template&id=4d31f613"
import script from "./inspection.vue?vue&type=script&lang=js"
export * from "./inspection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports